import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from 'react-bootstrap';
import { IPaymentDataStep } from '../steps/PaymentStep';
import { blankLink } from 'config';
import { useGarantieMaxActions } from '../GarantieMax';
import { PaymentMethodName } from 'Services/widgets/enums';

export interface IViewPaymentStep3Props {
  paymentData: IPaymentDataStep | null;
}

export const ViewPaymentStep3: React.FC<IViewPaymentStep3Props> = ( { paymentData } ) => {
  const { t } = useTranslation( [ 'widgets', 'base' ] );
  const actions = useGarantieMaxActions();

  const onClickEditStep = React.useCallback ( ( e ) => {
    e.preventDefault();
    actions.goToStep( 'payment', false );
  }, [ actions ] );

  return (
    <Fragment>
      { paymentData !== null && (
        <Card className="bg-none">
          <Card.Body>
            <div className="d-flex justify-content-between">
              <h3>{ t( 'bookingFunnel.steps.payment' ) }</h3>
              <a
                href={ blankLink }
                onClick={ ( e ) => { onClickEditStep( e ); } }
                title={ t( 'base:forms.edit' ) }
              >
                { t( 'base:forms.edit' ) }
              </a>

            </div>
            <hr className="mt-3 mb-3"></hr>
            <div className="text-left">
              <div className="details-section">
                <h5>{ t( 'bookingFunnel.paymentData.paymentMethod' ) }</h5>
                <p>{ paymentData?.paymentMethod === PaymentMethodName.Sepa ?
                  t( 'bookingFunnel.paymentData.sepaMandate' ) :
                  t( 'bookingFunnel.paymentData.bankTransfer' ) }
                </p>
              </div>
              { paymentData?.paymentMethod === PaymentMethodName.Sepa && (
                <Fragment>
                  <div className="details-section">
                    <h5>{ t( 'bookingFunnel.paymentData.accountName' ) }</h5>
                    <p>
                      { `${paymentData?.accountFirstName} ${paymentData?.accountLastName}` }
                    </p>
                  </div>
                </Fragment>
              ) }
            </div>
          </Card.Body>
        </Card>
      ) }
    </Fragment>
  );
};
